import { render, staticRenderFns } from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=template&id=1a3d4630&scoped=true&"
import script from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=style&index=0&id=1a3d4630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d4630",
  null
  
)

export default component.exports